/*jshint esversion: 6 */

$(function () {

    // flag, container za članke, element za animiranje
    var loadingArticles = false,
        $extraNewsContainer = $('.js_extraNewsContent');

    // funckija za dohvaćanje članaka
    function infiniteScroll() {

        // dohvati btn i url za članke
        var $btn        = $('.js_loadMore'),
            $animation  = $('.js_loadMoreAnimation'),
            url         = $btn.data('href');

        // ako btn postoji
        if( $btn.length > 0) {

            // na klik
            $btn.one('click', function() {

                // prikaži animaciju logo-a
                $animation.removeClass('is_hidden');

                $.ajax({
                    url: url,
                    type: 'GET',
                    dataType: 'html',
                })
                .done(function(data) {

                    // sakri animaciju logo-a
                    $animation.addClass('is_hidden');

                    // dohvaćene članke ubaci u container
                    $extraNewsContainer.append(data);

                    window.placeForDfp(true);

                    // reinicijaliziraj ovu funkciju tako da ona dohvati novi btn
                    infiniteScroll();

                    // resetiraj flag na false
                    loadingArticles = false;

                    stickyFill();

                });
            });

        } else {
            // if there is no button after articles are loaded,
            // add a class to the container ro remove padding-bottom
            $extraNewsContainer.addClass('is_full');
        }
    }

    function appendNewArticles() {

        // dohvati btn
        var $btn = $('.js_loadMore');

        // ako btn postoji
        if( $btn.length > 0 ) {

            // dohvati poziciju scrollbara, poziciju btn-a i visinu prozora
            var scrollTop     = $(window).scrollTop(),
                btnTopPos     = $btn.offset().top,
                windowHeight  = window.innerHeight;

            // napravi izračun na kojem treba početi loadanje članaka
            var math = btnTopPos - scrollTop - windowHeight;

            // ako je scrollbar došao do točke loadanja i trenutno se ne loadaju članci
            if( math < 500 && loadingArticles === false ) {

                // pretvori flag u true - loadanja članaka je u tijeku
                loadingArticles = true;

                // trigeraj klik buttona
                $btn.trigger('click');

                // ukloni button
                $btn.off().remove();
            }
        }
    }

    // inicijalni poziv funckije za dohvat članaka
    infiniteScroll();

    // pokretanje funkcije koja pokreće dohvat članaka
    $( window ).scroll( $.throttle( 300, appendNewArticles ) );

});
